// Graduated (tax-bracket style) pricing: each band's price applies only to the schools inside that band.
export const graduatedAnnualPrice = (n, bands) => (bands || []).reduce((sum, b) => {
  const hi = b.to == null ? n : b.to;
  return sum + Math.max(0, Math.min(n, hi) - b.from + 1) * b.price;
}, 0);

export const money = (v) => {
  const cents = Math.round(v * 100) % 100 !== 0;
  return `$${v.toLocaleString("en-US", { minimumFractionDigits: cents ? 2 : 0, maximumFractionDigits: 2 })}`;
};
